import AdminProductLicense from "interfaces/response/AdminProductLicense";
import AutoPurchasableProductLicense from "interfaces/response/AutoPurchasableProductLicense";
import LicenseRequest from "interfaces/request/LicenseRequest";
import { getDataAsync, putDataAsync, postDataAsync, deleteDataAsync } from "./PortalApi";

export const getProductLicenseAsync = async(productId: number) => {
  const routeUrl = `Products/${productId}/license`;
  const response = await getDataAsync<AdminProductLicense[]>(routeUrl);

  return response;
}

export const getAutoPurchasableProductLicenseAsync = async(productId: number) => {
  const routeUrl = `Products/${productId}/autoPurchasableLicense`;
  const response = await getDataAsync<AutoPurchasableProductLicense[]>(routeUrl);

  return response;
}

export const createProductLicenseAsync = async(data: LicenseRequest) => {
  const routeUrl = `ProductLicense`;

  return await postDataAsync<LicenseRequest, AdminProductLicense>(routeUrl, data);
}

export const updateProductLicenseAsync = async (licenseId: number, data: LicenseRequest) => {
  const routeUrl = `ProductLicense/${licenseId}`;

  return await putDataAsync<LicenseRequest, AdminProductLicense>(routeUrl, data);
};

export const deleteProductLicenseAsync = async (licenseId: number) => {
  const routeUrl = `ProductLicense/${licenseId}`;

  return await deleteDataAsync(routeUrl);
};